import { render, staticRenderFns } from "./DashFees.vue?vue&type=template&id=7d865a13&scoped=true&"
import script from "./DashFees.vue?vue&type=script&lang=js&"
export * from "./DashFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d865a13",
  null
  
)

export default component.exports